import { defineComponent as _defineComponent } from 'vue'
import BaseLayout from "@/layouts/template/BaseLayout.vue";
import DotHeader from "@/layouts/inc/Header.vue";
import DotSideMenu from "@/layouts/inc/SideMenu.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'SideMenuLayout',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { BaseLayout, DotHeader, DotSideMenu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})